import { Dispatch, SetStateAction } from 'react';
import { get } from 'scripts';
import { API } from '../../data/30pay.api';
import { FiatType, Market } from 'interfaces';

export const getPrices = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Market[]>>,
    page: number,
    pageSize: number,
) => {
    setLoading(true);
    await get<Market[]>(API.market.prices(page, pageSize))
        .then((response) => {
            setData(response.value.value);
        })
        .catch((error) => console.log(error))
        .finally(() => setLoading(false));
};

export const getFiats = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<FiatType[]>>,
) => {
    setLoading(true);
    await get<FiatType[]>(API.fiat.all)
        .then((response) => {
            setData(response.value.value);
        })
        .catch((error) => console.log(error))
        .finally(() => setLoading(false));
}